module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAkCAIAAADO/WchAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABBSURBVChTY/j8+fPWrVvnzZsHJIFsBiA1EwaAbAagDJQ3cyaQjSEP0T9nzhwgCdL/HwwePHgAYYzywWCY8v//BwCOtvfdP5m7QgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/oldmemorabiliaMini.png
// module id = sMqB
// module chunks = 1